export const STATUS_PENDING = 'PENDING'
export const STATUS_APPROVED = 'APPROVED'
export const STATUS_REJECTED = 'REJECTED'

export const UPPER_CASE = 'UPPER_CASE'
export const CAPITALIZE_CASE = 'CAPITALIZE_CASE'
export const LOWER_CASE = 'LOWER_CASE'
